<template>
  <div id="app">
    <router-view />
    <div id="message-box" />

    <div
      id="mloading"
      class="loading"
    >
      <div class="loading-cover" />
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <modals-container />
    <dialog-wrapper />
    <ms-tracking-box />
  </div>
</template>

<script>
import { DialogWrapper } from 'vue3-promise-dialog'
import MsTrackingBox from '@/components/trackingBox'
// import { ModuleContext } from '@/stores/moduleConst'
// import { mapGetters } from 'vuex'

export default {
  components: {
    DialogWrapper,
    MsTrackingBox,
  },
  // các static event của WS
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    // 'connect',
    // 'error',
    // 'disconnect',
    // 'reconnect',
    // 'reconnect_attempt',
    // 'reconnecting',
    // 'reconnect_error',
    // 'reconnect_failed',
    // 'connect_error',
    // 'connect_timeout',
    // 'connecting',
    // 'ping',
    // 'pong'
  },

  data () {
    return {}
  },

  computed: {
    // ...mapGetters(ModuleContext, ['Token']),
  },

  watch: {
    // Token (newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     window.postMessage('changeStatus', window.location.origin)
    //   }
    // },
  },

  created () {
  },

  mounted () {
    // window.addEventListener('message', (event) => {
    //   if (
    //     event.origin === window.location.origin &&
    //     event.data === 'changeStatus'
    //     // !location.pathname.contain('/account/login')
    //   ) {
    //     this.$tabs.refreshAll()
    //   }

    //   // …
    // }, false)
  },

  methods: {
    /**
     * Next control khi ấn Enter
     */
    initEnterSameTab () {
      const me = this

      window.addEventListener('keydown', function (e) {
        if (e.which === 13 && !e.shiftKey) {
          const tag = e.target.tagName.toLowerCase()
          if (['button', 'a', 'textarea'].includes(tag)) {
            return
          }

          // Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          // Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (
            e.target.closest('.ms-grid-viewer') &&
            e.target.closest('tbody')
          ) {
            return
          }

          // Với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest('.remain-focus-when-enter')) {
            return
          }
          const focusable = me.$ms.commonFn.focusNextControl(e.target)
          if (focusable) {
            e.preventDefault()
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
}
</style>
